'use client';

import { c as _c } from "react/compiler-runtime";
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context';
import { TopNavV5DesktopBar } from '@src/components/TopNavV5/TopNavV5Desktop/TopNavV5DesktopBar';
import { TopNavV5DesktopSlidingPanel } from '@src/components/TopNavV5/TopNavV5Desktop/TopNavV5DesktopSlidingPanel';
import { cn } from '@src/utils/tailwind';
export const TopNavV5Desktop = () => {
  const $ = _c(11);
  const {
    isExpanded,
    setExpanded
  } = useTopNavV5();
  let t0;
  if ($[0] !== setExpanded) {
    t0 = () => setExpanded(false);
    $[0] = setExpanded;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TopNavV5DesktopBar />;
    t2 = <TopNavV5DesktopSlidingPanel />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isExpanded) {
    t3 = cn("invisible fixed inset-0 z-30 transition-all", {
      "backdrop-blur-sm visible bg-bodi-black-text/80": isExpanded
    });
    $[4] = isExpanded;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className={t3} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t4) {
    t5 = <nav className="relative hidden lg:block" id="styled-nav-com-4369" onMouseLeave={t0}>{t1}{t2}{t4}</nav>;
    $[8] = t0;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};